import React from "react";

import { Box, Typography } from "@material-ui/core";

import { publicPath } from "@ip-utils";
import { Button } from "@ip-widgets";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    return {
      error,
    };
  }

  reload = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.reload(true);
  };

  render() {
    if (this.state.error) {
      return (
        <Box
          alignItems="center"
          display="flex"
          flexDirection="column"
          height="100vh"
          justifyContent="center"
          textAlign="center"
        >
          <Box marginBottom={3} maxWidth={200} width="80%">
            <img alt="iglu" src={publicPath("/media/iglu.svg")} width="100%" />
          </Box>
          <Box marginBottom={3} marginTop={5}>
            <Typography variant="h1">Oops, something went wrong</Typography>
          </Box>
          <Box marginBottom={5}>
            <Typography variant="subtitle1">
              The application needs to restart to make things work again
            </Typography>
          </Box>
          <Box>
            <Button onClick={this.reload}>Restart</Button>
          </Box>
        </Box>
      );
    }

    return this.props.children;
  }
}
